import gql from 'graphql-tag';

export default gql`
  query suggestionsSummaryQuery($suggestionsListId: ID!) {
    suggestionsList(suggestionsListId: $suggestionsListId) {
      id
      state
      lastRequestedChanges
      lastSubmissionAt
      lastRequestedChangesAt
      comments {
        user
        content
        createdAt
        userInstitution
      }
      acceptedSuggestionsCount
      rejectedSuggestionsCount
      suggestionsCount

      acceptedSuggestionsTotalCost {
        value
        currency
      }
      rejectedSuggestionsTotalCost {
        value
        currency
      }
      suggestionsTotalCost {
        value
        currency
      }
      library {
        id
        name
      }

      project {
        id
        name
        goal
        state
        requirements {
          keywords
          budget
        }
        createdAt
      }
    }
  }
`;
